(function ($, Global) {
    var OffrePage = function () {
        // Déclaration class objet
    }

    OffrePage.prototype.initEvents = function () {        
        this.publishers();
        this.selectOffer();
    }

    OffrePage.prototype.publishers = function () {
        var self = this
        var catchTrigger = false;
        $('.offer .card-header').on('click', function (e) {
            if ($(this).attr('aria-expanded') == 'true') {
                e.stopPropagation();
            }
        });
        $('.offer-detail').on('shown.bs.collapse', function () {
            if (catchTrigger) {
                Global.dataLayer.push({
                    event: 'offerSelected',
                    typeOffre: $(this).find('[name=typeOffre]').val()
                })
            }
            var windowWidth = $(window).outerWidth()
            if (windowWidth >= Global.viewports.md) return;

            var $offerHeader = $(this).closest('.offer');
            var scrollTop = $offerHeader.offset().top;

            $('html, body').stop().animate({
                scrollTop: scrollTop
            }, 'slow');
        });
        $('.select-regions [name*=regions]').change(function (e) {
            var $this = $(this);
            var selected = $this.val();
            var $selector = $this.closest('.select-regions');
            $selector.find("[data-region-id].show").removeClass('show');
            $selector.find("[data-region-id='" + selected + "']").addClass('show');
            $this.closest('.offer-detail').find("[name=region]").val(selected);
            self.selectAndShowPriceForLicencePro();
            if (catchTrigger) {
                Global.dataLayer.push({
                    event: 'regionAfricaSelected',
                    region: selected
                });
            }
        });
        
        $(".select-readers input").on("input", function () {
            var tempSliderValue = $(this).val();
            var publicationsColor = {
                AI: '#eb7c2d',
                IO: '#b21f24',
                LL: '#cc1800',
                GL: '#652f89'
            };
            var publicationColorCurrent = getCurrentPublication();
            if (tempSliderValue == 0) {
                tempSliderValue = 1
                $(this).val(tempSliderValue);
            }
            var indexSelected = tempSliderValue;
            var $parent = $(this).closest(".select-readers");
            var $readersSelected = $parent.find(".readers-selected");
            var $option = $parent.find('option').eq(indexSelected);
            var progress = (tempSliderValue / $(this).attr("max")) * 100;
            $(this).css(
                "background",
                "linear-gradient(to right, " + publicationsColor[publicationColorCurrent] + " " + progress + "%, #fff " + progress + "%)"
            );
            $parent.find('option').removeClass('selected');
            $option.addClass('selected');
            $readersSelected.text($option.data('selected'))
            $parent.closest('.offer-detail').find('[name*=nbLecteurs]').val($option.attr('value'));
            self.selectAndShowPriceForLicencePro();
        });
        $('[name*=selectDevise]').on('change', function (e) {
            var $this = $(this);
            var $inputDevise = $this.closest('.offer-detail').find('[name*=devise]');
            $inputDevise.val($this.val());
            self.selectAndShowPriceForLicencePro();
        });

        $('.btn-subscribe').on('click', function (e) {
            var $this = $(this);
            var $offer = $this.closest('.offer-detail');
            var data = {
                TypeOffreSelectionnee: $offer.find('[name=typeOffreSelectionnee]').val(),
                Region: $offer.find('[name=region]').val(),
                NbLecteurs: $offer.find('[name=nbLecteurs]').val(),
                Devise: $offer.find('[name=devise]').val()
            }
            $.ajaxPost('/ajax/subscriptionsv2/onlinesubscription', data)
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: function () {
                            Global.location.href = result.data
                        }
                    });
                });
        });
        $('.btn-subscribe-disconnect').on('click', function (e) {
            var $this = $(this);
            var $offer = $this.closest('.offer-detail');
            var context = "subscription";
            var modalId = 'modalSignup' + (context || '');
            var data = {
                context: context,
                typeOffre: $offer.find('[name=typeOffreSelectionnee]').val(),
                region: $offer.find('[name=region]').val(),
                nbLecteurs: $offer.find('[name=nbLecteurs]').val(),
                devise: $offer.find('[name=devise]').val()
            }
            if ($('#' + modalId).exists()) {
                $('#' + modalId).remove();
            }
            $.Topic('loader-show').publish();
            $.ajaxGet('/ajax/signup', data)
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: function () {
                            $('body').append(self.templateSignupModal(result.data.html, modalId, context));
                            $('#' + modalId).modal('show').on('shown.bs.modal', function () {
                                $.Topic('loader-hide').publish();
                            });
                        }
                    });
                })
        });

        $('.btn-subscribe, .btn-subscribe-disconnect').on('click', function (e) {
            var $this = $(this);
            var $offer = $this.closest('.offer-detail');
            Global.dataLayer.push({
                event: 'subcribeClicked',
                typeOffre: $offer.find('[name=typeOffre]').val()
            })
        })

        $('.btn-quote').on('click', function (e) {
            var $this = $(this);
            var $offer = $this.closest('.offer-detail');
            Global.dataLayer.push({
                event: 'requestQuote',
                typeOffre: $offer.find('[name=typeOffre]').val()
            })
        });

        $(document).ready(function () {
            $('.select-regions').each(function () {
                $(this).find('[name*=regions]').first().prop("checked", true).trigger("change");
            });
            $(".select-readers #readerRange").val(1).trigger("input");

            setTimeout(function () {
                catchTrigger = true;
            }, 500);
        });
    }

    OffrePage.prototype.templateSignupModal = function (contentHtml, id, context) {
        return [
            '<div id="' + id + '" class="modal fade signup-modal" tabindex="-1" role="dialog">',
            '<div class="modal-dialog" role="document">',
            contentHtml,
            '</div>',
            '</div>'
        ].join('')
    }

    OffrePage.prototype.selectAndShowPriceForLicencePro = function () {
        $('#offers > .offer').each(function () {
            var $this = $(this);
            var listBouquetService = Object.keys(Global.OFFRES_PRIX);
            var region = $this.find('[name=region]').val();
            var bouquetService = !region || region.toLowerCase() == "touteafrique" ? listBouquetService[0] : listBouquetService[1];
            var devise = $this.find('[name*=devise]').val();
            var readers = $this.find('[name*=nbLecteurs]').val();
            var $oldPrice = $this.find('.price-wrapper .old-price');
            var $price = $this.find('.price-wrapper .price');
            var $reduc = $this.find('.price-wrapper .offer-reduc');

            if (!Global.OFFRES_PRIX || !bouquetService || !devise || !readers) return;

            var price = Global.OFFRES_PRIX[parseInt(bouquetService, 10)][devise].find(function (p) {
                return p.NbLecteur == parseInt(readers, 10);
            });
            if (!price) return;
            if (price.Prix.TarifAvantReduc) $oldPrice.text(formatPrice(price.Prix.TarifAvantReduc, devise));
            else $oldPrice.text('');
            $price.text(formatPrice(price.Prix.Tarif, devise));
            $reduc.text(price.Prix.ReductionPourcentage && parseInt(price.Prix.ReductionPourcentage, 10) > 0 ? '(-' + price.Prix.ReductionPourcentage + '%)' : '');
        });

        function formatPrice(price, devise) {
            var locale = Global.LANG == 'Francais' ? 'fr-FR' : 'en-EN';
            var localeOptions = {
                style: "currency",
                currency: devise,
                currencyDisplay: 'narrowSymbol',
                minimumFractionDigits: Number.isInteger(price) ? 0 : 2
            }
            return price.toLocaleString(locale, localeOptions);
        }
    }

    OffrePage.prototype.selectOffer = function () {
        var hash = Global.location.hash;
        if (hash && $(hash).exists()) {
            $(hash).trigger('click');
            var top = $('.offer-detail[aria-labelledby="' + hash.replace('#','') +'"]').offset().top;
            if (top != null) $('html, body').animate({ scrollTop: top });
        }
    }

    function getCurrentPublication() {
        if ($('body').hasClass('SiteGLF') || $('body').hasClass('SiteGLA')) return 'GL';
        else if ($('body').hasClass('SiteAIF') || $('body').hasClass('SiteAIA')) return 'AI';
        else if ($('body').hasClass('SiteLMR') || $('body').hasClass('SiteINT')) return 'IO';
        else if ($('body').hasClass('SiteLLA')) return 'LL';
    }

    Global.OffrePage = OffrePage;
}(jQuery, window));